import api, { ApiResponse } from './api';

import { ClassificationSubgroup } from 'entities/ClassificationSubgroup';

interface GetClassificationSubgroupListResponse {
  success: boolean;
  data: ClassificationSubgroup[];
}

export const getClassificationSubgroupListService =
  (): ApiResponse<GetClassificationSubgroupListResponse> =>
    api({
      method: 'GET',
      url: 'classification-subgroups',
      useToken: true,
    });
